import { type GenerationTool, getToolDefaultAssetType } from 'src/data/generationTool';
// @ts-expect-error - useTextSensitivityDebounced has no TypeScript declarations
import { useTextSensitivityDebounced } from 'src/services/useTextSensitivityDebounced';
// @ts-expect-error - project store has no TypeScript declarations
import { useCurrentProjectId } from 'src/store/project/useCurrentProjectId';

import { LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT } from './longFormConst';

interface Params {
  generationTool?: GenerationTool | null;
  text: string;
}

export const useLongFormSensitivityData = ({ generationTool, text }: Params) => {
  const projectId = useCurrentProjectId();
  const assetType = generationTool ? getToolDefaultAssetType(generationTool) : undefined;

  return useTextSensitivityDebounced(
    { projectId, assetType, text },
    {
      debounceTimeout: LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT,
      disabled: !projectId,
    }
  );
};
